export {
  BuildHTML as BuildHtml,
  type BuildHTMLProps as BuildHtmlProps,
} from "./BuildHtml";
